<template>
  <div class="select-date">
    <span>选择日期</span>
    <div class="date-wrap">
      <div class="select-box">
        <div @click="DateClick(0)">{{ dateArr[0] | regroupDate }} <i>▲</i></div>
        <span>至</span>
        <div @click="DateClick(1)">{{ dateArr[1] | regroupDate }} <i>▼</i></div>
      </div>
      <span class="btn-query" @click="queryBtnClick">查找</span>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @confirm="onConfirm"
        active-class="active-date"
        confirm-button-text="完成"
        :title="datePickerTitle"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>
<script>
const ONE_DAY = 1000 * 60 * 60 * 24;
const currDate = Date.now();
export default {
  data() {
    return {
      datePickerTitle: '开始时间',
      currentDate: new Date(),
      show: false,
      dateIndex: 0,
      minDate: new Date(2021, 0, 1),
      defaultDate: new Date(),
    };
  },
  model: {
    prop: 'dateArr',
    event: 'change',
  },
  props: {
    dateArr: {
      type: Array,
      default: function () {
        return [new Date(currDate - ONE_DAY), new Date()];
      },
    },
    queryBtnClick: {
      type: Function,
      default: () => {},
    },
  },
  filters: {
    regroupDate(val) {
      let time = new Date(val);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
  },
  methods: {
    DateClick(dateIndex) {
      this.dateIndex = dateIndex;
      this.datePickerTitle = dateIndex ? '结束时间' : '开始时间';
      this.currentDate = new Date(this.dateArr[dateIndex]);
      this.show = true;
    },
    getTime(time) {
      if (time instanceof Date) {
        time = time.getTime();
      }
      return time;
    },
    onConfirm(date) {
      let newDateArr = [];
      if (this.dateIndex) {
        newDateArr[1] = this.getTime(date);
        newDateArr[0] = this.getTime(this.dateArr[0]);
      } else {
        newDateArr[0] = this.getTime(date);
        newDateArr[1] = this.getTime(this.dateArr[1]);
      }
      if (newDateArr[0] > newDateArr[1]) {
        return this.$Toast('结束日期不能在开始日期之前');
      } else {
        this.dateArr[this.dateIndex] = this.getTime(date);
        this.show = false;
      }
      this.$emit('change', newDateArr);
    },
  },
};
</script>

<style lang="less" scoped>
.select-date {
  font-size: 26px;
  display: flex;
  align-items: center;

  .date-wrap {
    flex: 1;
    height: 56px;
    margin-left: 20px;
    display: flex;
    justify-content: space-between;
    .select-box {
      flex: 1;
      border: 1px solid #d9d9d9;
      display: flex;
      align-items: center;
      justify-content: space-around;
      border-radius: 4px;
      padding-left: 10px;
      div {
        i {
          color: #bfbfbf;
          font-size: 24px;
        }
      }
      span {
        color: #bfbfbf;
      }
    }
    .btn-query {
      width: 90px;
      height: 56px;
      line-height: 56px;
      text-align: center;
      background: #f5f5f5;
      border: 1px solid #d9d9d9;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      margin-left: -2px;
    }
  }
}
</style>
